"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getProviderById = exports.getAppointmentById = exports.cancelAppointmentById = void 0;
var _utils = require("./utils");
/**
 * Function to call the `getAppointment` callback, extract the data from it,
 * and return the converted form for use in the state machine.
 * @param {*} getAppointmentCallback Callback to make an API request to get an appointment.
 *                                   Returns the HTTP Response.
 *                                   Appointment data will be nested under `data` in `appointment` and `capabilities`.
 * @param {*} appointmentId The id of the appointment we're requesting.
 * @returns The converted appointment object to be stored in the machine context.
 */
const getAppointmentById = async (getAppointmentCallback, appointmentId) => {
  const appointmentResponse = await getAppointmentCallback(appointmentId);
  return (0, _utils.convertAppointment)(appointmentResponse.data);
};

/**
 * Function to call the `getProvider` callback, and return the data from it.
 * @param {*} getProviderCallback Callback to make an API request to get a provider.
 *                                Returns the HTTP Response.
 *                                Provider data should be top level.
 * @param {*} providerId The id of the provider we're requesting.
 * @returns The requested provider
 */
exports.getAppointmentById = getAppointmentById;
const getProviderById = async (getProviderCallback, providerId) => {
  const providerResponse = await getProviderCallback(providerId);
  return {
    provider: providerResponse.data.data.provider,
    locations: providerResponse.data.data.locations
  };
};

/**
 * Function to call the `cancelAppointment` callback, and return the data from it.
 * @param {*} cancelAppointmentCallback Callback to make an API request to cancel an appointment.
 *                                      Returns the HTTP Response.
 * @param {*} appointmentId The id of the appointment we're canceling.
 * @param {*} cancelEmail The email to send the cancel confirmation to
 * @param {*} cancelEmailConsent Boolean representing consent to receive an email.
 * @param {*} cancelReasonText Optional text reason why appointment is being canceled.
 */
exports.getProviderById = getProviderById;
const cancelAppointmentById = async (cancelAppointmentCallback, appointmentId, cancelEmailConsent, cancelReasonText) => {
  await cancelAppointmentCallback(appointmentId, cancelEmailConsent, cancelReasonText);
};
exports.cancelAppointmentById = cancelAppointmentById;